import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "k-breadcrumbs flex inline" }

import { useRoute, useRouter } from 'vue-router'
import type { RouteLocationRaw } from 'vue-router'
import { computed } from 'vue'

type Crumbs = { to: RouteLocationRaw; title: string }[]
interface IProps {
  customCrumbs?: Crumbs
  activeClass?: string | (string | Record<string, boolean>)[] | Record<string, boolean>
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KBreadcrumbs' },
  __name: 'KBreadcrumbs',
  props: {
    customCrumbs: { default: () => [] },
    activeClass: { default: 'text-cool-gray-80' }
  },
  setup(__props: any) {



const props = __props

const [route, router] = [useRoute(), useRouter()]

const crumbs = computed(() => {
  if (props.customCrumbs.length) return props.customCrumbs

  const fullPath = route.fullPath
  const params = fullPath.substring(1).split('/')
  const crumbs: Crumbs = []

  let path = ''
  params.forEach((param) => {
    path += `/${param}`
    const match = router.resolve(path)

    if (match.path !== null && param !== '') {
      crumbs.push({ to: match, title: decodeURI(param) })
    }
  })

  return crumbs
})

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(crumbs.value, (crumb, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: _normalizeClass(["flex items-center fs-14px fw-400 k-breadcrumbs__items transition", { 'k-breadcrumbs__items--hoverless': !crumb.to }])
      }, [
        (index + 1 !== crumbs.value.length)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(crumb.to ? 'router-link' : 'span'), {
              key: 0,
              to: crumb.to,
              class: "text-inherit text-decoration-none flex items-center q-mr-xs"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(crumb.title) + " ", 1),
                _createVNode(_component_KIcon, {
                  name: "arrow-right",
                  size: "20px",
                  color: "inherit",
                  class: "q-ml-xs"
                })
              ]),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(__props.activeClass)
            }, _toDisplayString(crumb.title), 3))
      ], 2))
    }), 128))
  ]))
}
}

})